<template>
  <div class="employee">

    <!-- <div style="display:flex;justify-content:flex-end">
      <v-button type="primary" @click="showFilters">
        <v-icon type="filters"></v-icon>
      </v-button>
    </div> -->
    <v-modal title="Filters" :visible="filtersVisible" @cancel="cancelFilters">
      <div class="filter-wrap">
        <div class="status-filter-wrap">
          <b>Application Status: &emsp;</b><v-select placeholder="Filter by status" size="large" v-model="statusFilter"
            :data="applicationStatuses" @change="(value) => applyStatusFilter(value)"></v-select>
        </div>
      </div>

      <div slot="footer">
        <v-button key="cancel" type="ghost" size="large" @click="cancelFilters">Cancel</v-button>
        <v-button key="confirm" type="primary" size="large" @click="applyFilters">Apply</v-button>
      </div>
    </v-modal>

    <div style="overflow-y: auto;height: 500px;margin-top: 20px;">
      <div v-if="applicationSelected" class="application-view">
        <ApplicationView :application="applicationSelected" :close="closeDetailView" />
      </div>

      <div class="application-header" v-for="application of applications" :key="application.id"
        v-if="applications">
        <span>
          {{optionsStudyLevels[application.level_of_study]}} - {{application.area_of_study}}, {{application.school.province}}
        </span>
        <span>
          <v-button type="warning" size="small" @click="() => showApplicationDetails(application)">View Details</v-button>
        </span>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ApplicationView from './ApplicationView'

export default {
  name: 'EmployeeApplicationsView',
  data () {
    return {
      applicationSelected: null,
      filtersVisible: false,
      applicationStatuses: [
        {label: 'Applied', value: 'Applied'}
      ],
      statusFilter: 'Applied',
      optionsStudyLevels: {
        G10: 'Grade-10',
        G12: 'Grade-12',
        D1: '1-Year Post-Secondary Certificate',
        D2: '2-Year Undergraduate Diploma',
        D3: '3-Year Undergraduate Advanced Diploma',
        B4: '4-Year Bachelor\'s Degree',
        PG: 'Postgraduate Certificate / Master\'s Degree'
      }
    }
  },
  computed: {
    ...mapGetters([
      'applications'
    ])
  },
  watch: {
    applications: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getApplications', 'Applied')
        }
      },
      immediate: true
    }
  },
  methods: {
    showFilters () {
      this.filtersVisible = true
    },
    applyFilters () {
      this.filtersVisible = false
    },
    cancelFilters () {
      this.filtersVisible = false
    },
    showApplicationDetails (application) {
      this.applicationSelected = application
    },
    closeDetailView () {
      this.applicationSelected = null
    },
    applyStatusFilter (value) {

    }
  },
  components: {
    ApplicationView
  }
}
</script>

<style scoped>
.filter-wrap {
  display: flex;
  align-items: flex-start;
}
.filter-wrap .status-filter-wrap {
  width: 240px;
  display: flex;
  align-items: flex-start;
}
.filter-wrap .status-filter-wrap select {
  width: 100%;
}
.application-header {
  height: 38px;
  line-height: 38px;
  padding: 0 12px;
  color: rgba(0,0,0,.85);
  position: relative;
  -webkit-transition: all .3s;
  transition: all .3s;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
.application-header:hover {
  background-color: #dadada;
}
.application-view {
  margin: 0 12px 20px;
  padding: 12px;
  -webkit-box-shadow: 0px 0px 5px 2px rgba(74,74,74,0.72);
  -moz-box-shadow: 0px 0px 5px 2px rgba(74,74,74,0.72);
  box-shadow: 0px 0px 5px 2px rgba(74,74,74,0.72);
}
</style>

<style>
.ant-select.ant-select-large {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Employee/Applications/EmployeeApplicationsView.vue